// string {{var}} string

const Translations = {
  slug: {
    chapters: 'hoofdstukken',
    endtest: 'zelftoets',
    endtestTest: 'toets',
    endtestIntro: 'intro',
    endtestPassed: 'geslaagd',
    endtestNotPassed: 'niet-geslaagd',
  },

  app: {
    home: 'Home',
    help: 'Help',
    logout: 'Uitloggen',
    next: 'Volgende',
    back: 'Vorige',
    submitQuiz: 'Controleer antwoord',
    loadingError: 'Error Occurred',
    offlineMode: 'Offline Mode',
    exercise: 'Oefening',
    toggleIdModalLabel: 'ID NUMMERS',
  },

  home: {
    title: 'Goedemiddag {{name}}',
    description: 'Leer meer over de basis van het slepen van een vliegtuig.',
  },

  endtest: {
    title: 'Zelftoets',
    // description: 'Je kunt nu bijna deze e-learning over systeemgerichte contractbeheersing succesvol afronden! Hiervoor moet je een voldoende (7 punten) halen op de zelftoets.',
    introTextHTML: '<p>Deze toets bestaat uit 15 vragen, waarmee je in totaal 15 punten kunt halen. Mocht je de eerste keer geen 11 punten halen dan kun je de vragen inzien, om te ontdekken wat er niet goed ging. We geven dan ook aan welke module(s) je het beste nog even kunt doornemen. Vervolgens kun je de zelftoets nog een keer maken.</p>',
    questionNo: 'Vraag {{number}}',
    passedTitle: 'Goed gedaan!',
    passedDescription: 'Je hebt voldoende punten gehaald op de zelftoets.',
    notPassedTitle: 'Helaas...',
    notPassedDescription: 'Je hebt niet voldoende punten gehaald op de zelftoets.',
    infoMessageTitle: 'Neem deze informatie nog een keer door',
    btnStart: 'Start zelftoets',
    btnSubmit: 'Bekijk resultaat',
    btnResults: 'Bekijk antwoorden',
    btnRetry: 'Probeer opnieuw',
    btnExit: 'Terug naar hoofdmenu',
  },

  card: {
    start: 'Start',
    continue: 'Ga verder',
    nextModule: 'Volgend hoofdstuk',
    again: 'Nogmaals bekijken',
    doneMessage: 'Succesvol afgerond!',
  },

  modal: {
    logoutHtmlTitle: 'Jouw voortgang<br/>is opgeslagen!',
    logoutHtmlText: '<p>We hebben jouw voortgang succesvol opgeslagen. <br />Je kunt dit scherm nu sluiten.</p>', },
}

export const translate = (key, params) => {
  const keys = key.split('.')

  return Translations[keys[0]][keys[1]].replace(/\{{(\S+?)\}}/g, (match, ...args) => params[args[0]])
}



// WEBPACK FOOTER //
// ./src/translations.js